import { ActionType } from '@ant-design/pro-components';
import { useRef, useState } from 'react';

export default () => {
  const [loading, setLoading] = useState(false);
  const actionRef = useRef<ActionType>();

  return { actionRef, loading, setLoading };
};
